import { render, staticRenderFns } from "./UserFixedPhraseSelector.vue?vue&type=template&id=fddeb344&scoped=true&"
import script from "./UserFixedPhraseSelector.vue?vue&type=script&lang=ts&"
export * from "./UserFixedPhraseSelector.vue?vue&type=script&lang=ts&"
import style0 from "./UserFixedPhraseSelector.vue?vue&type=style&index=0&id=fddeb344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddeb344",
  null
  
)

export default component.exports